import React from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileCheck } from "lucide-react";

export const documents = [
    {
        title: "Employment Contract",
        type: "Contract",
        description: "Initial employment contract signed upon joining the company.",
        date: "2023-01-15",
        size: "2.4 MB",
        status: "Active",
        icon: <FileCheck className="w-5 h-5 text-blue-600" />,
        docID: "DOC001",
    },
    {
        title: "Contract Amendment - Remote Work",
        type: "Contract",
        description: "Amendment allowing permanent remote work arrangement.",
        date: "2023-06-20",
        size: "1.8 MB",
        status: "Active",
        icon: <FileCheck className="w-5 h-5 text-blue-600" />,
        docID: "DOC002",
    },
    {
        title: "Non-Disclosure Agreement",
        type: "Contract",
        description: "Confidentiality and non-disclosure agreement.",
        date: "2023-01-15",
        size: "1.2 MB",
        status: "Active",
        icon: <FileCheck className="w-5 h-5 text-blue-600" />,
        docID: "DOC003",
    },
];

const ContractsDocument = () => {

    return (
        <div className="space-y-3">
            {documents.map((doc, index) => (
                <DocumentCard
                    key={index}
                    {...doc}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default ContractsDocument;
